import React from "react";
//#region types
import { StyleEnums } from "models/enums";
import { IconDefinitionConstants } from "utils/constants";
import { EditableTableRowActionsProps } from "models/propTypes/genericFormProps";
//#endregion
//#region components
import MenuButton from "../../../buttons/menuButton";
import RoundButton from "../../../buttons/roundButton";
import Icon from "../../../icon";
import { TableCell } from "@mui/material";
import { useFormikContext } from "formik";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const EditableTableRowActions: React.FC<EditableTableRowActionsProps> = (props) => {
  const { rowKey, removeRowClickHandler, isLastRow, moreActions, row, rowIndex } = props;

  const formikProps = useFormikContext();
  return (
    <TableCell
      key={`tab-cell-${rowKey}-remove`}
      onDragStart={(event) => {
        event.stopPropagation();
        event.preventDefault();
      }}
      draggable
      className={cssExports.editableTableActionButton}
    >
      {!isLastRow &&
        (moreActions ? (
          <MenuButton
            menuPlacement="bottom"
            menuItems={
              moreActions(row)?.map((m) =>
                typeof m === "object"
                  ? {
                      ...m,
                      onClickHandler: m.onClickHandler?.bind(null, rowIndex, row, formikProps),
                    }
                  : m
              ) ?? []
            }
            button={
              <RoundButton size="xs" displayType={StyleEnums.DisplayType.None} className={cssExports.listMoreActions}>
                <Icon icon={IconDefinitionConstants.WEllipsisH} />
              </RoundButton>
            }
            classes={{
              menuOpen: cssExports.listMoreActionsMenuOpen,
            }}
          />
        ) : (
          <RoundButton
            size="xs"
            displayType={StyleEnums.DisplayType.None}
            className={cssExports.close}
            onClick={(event: React.MouseEvent<HTMLElement, MouseEvent>) => removeRowClickHandler(event, rowIndex)}
          >
            <Icon icon={IconDefinitionConstants.WTimes} />
          </RoundButton>
        ))}
    </TableCell>
  );
};

export default EditableTableRowActions;
